/**
 * Back in Stock Notification System
 * Integrates with Klaviyo API for email notifications
 */

// Texts for the validation / limit messages, per storefront language (first 2 letters of <html lang>).
const BIS_I18N = {
  "es": {
    "invalidEmail": "Introduce un email válido.",
    "generic": "Algo ha fallado. Inténtalo de nuevo.",
    "tooMany": "Demasiados intentos. Inténtalo más tarde.",
    "already": "Ya te has suscrito a esta talla. Podrás volver a hacerlo en {time}.",
    "maxSizes": "Has alcanzado el máximo de {max} tallas para este producto. Inténtalo de nuevo en 24 horas.",
    "maxProducts": "Has alcanzado el máximo de productos suscritos. Inténtalo de nuevo en 24 horas.",
    "hourOne": "1 hora",
    "hourOther": "{n} horas"
  },
  "en": {
    "invalidEmail": "Please enter a valid email address.",
    "generic": "Something went wrong. Please try again.",
    "tooMany": "Too many requests. Please try again later.",
    "already": "You've already subscribed to this size. You can subscribe again in {time}.",
    "maxSizes": "You've reached the maximum of {max} size subscriptions for this product. Please try again in 24 hours.",
    "maxProducts": "You've reached the maximum number of product subscriptions. Please try again in 24 hours.",
    "hourOne": "1 hour",
    "hourOther": "{n} hours"
  },
  "fr": {
    "invalidEmail": "Veuillez saisir une adresse e-mail valide.",
    "generic": "Une erreur est survenue. Réessayez.",
    "tooMany": "Trop de tentatives. Réessayez plus tard.",
    "already": "Vous êtes déjà inscrit pour cette taille. Vous pourrez vous réinscrire dans {time}.",
    "maxSizes": "Vous avez atteint le maximum de {max} tailles pour ce produit. Réessayez dans 24 heures.",
    "maxProducts": "Vous avez atteint le nombre maximum de produits suivis. Réessayez dans 24 heures.",
    "hourOne": "1 heure",
    "hourOther": "{n} heures"
  },
  "de": {
    "invalidEmail": "Bitte gib eine gültige E-Mail-Adresse ein.",
    "generic": "Etwas ist schiefgelaufen. Bitte versuch es erneut.",
    "tooMany": "Zu viele Anfragen. Bitte versuch es später erneut.",
    "already": "Du hast dich für diese Größe bereits angemeldet. Du kannst dich in {time} erneut anmelden.",
    "maxSizes": "Du hast das Maximum von {max} Größen für dieses Produkt erreicht. Versuch es in 24 Stunden erneut.",
    "maxProducts": "Du hast die maximale Anzahl an Produkt-Benachrichtigungen erreicht. Versuch es in 24 Stunden erneut.",
    "hourOne": "1 Stunde",
    "hourOther": "{n} Stunden"
  },
  "it": {
    "invalidEmail": "Inserisci un indirizzo email valido.",
    "generic": "Qualcosa è andato storto. Riprova.",
    "tooMany": "Troppi tentativi. Riprova più tardi.",
    "already": "Sei già iscritto per questa taglia. Potrai iscriverti di nuovo tra {time}.",
    "maxSizes": "Hai raggiunto il massimo di {max} taglie per questo prodotto. Riprova tra 24 ore.",
    "maxProducts": "Hai raggiunto il numero massimo di prodotti. Riprova tra 24 ore.",
    "hourOne": "1 ora",
    "hourOther": "{n} ore"
  },
  "pt": {
    "invalidEmail": "Introduz um email válido.",
    "generic": "Algo correu mal. Tenta novamente.",
    "tooMany": "Demasiadas tentativas. Tenta mais tarde.",
    "already": "Já subscreveste este tamanho. Podes voltar a subscrever dentro de {time}.",
    "maxSizes": "Atingiste o máximo de {max} tamanhos para este produto. Tenta novamente dentro de 24 horas.",
    "maxProducts": "Atingiste o número máximo de produtos subscritos. Tenta novamente dentro de 24 horas.",
    "hourOne": "1 hora",
    "hourOther": "{n} horas"
  },
  "pl": {
    "invalidEmail": "Podaj prawidłowy adres e-mail.",
    "generic": "Coś poszło nie tak. Spróbuj ponownie.",
    "tooMany": "Zbyt wiele prób. Spróbuj później.",
    "already": "Masz już zapis na ten rozmiar. Możesz zapisać się ponownie za {time}.",
    "maxSizes": "Osiągnięto limit {max} rozmiarów dla tego produktu. Spróbuj ponownie za 24 godziny.",
    "maxProducts": "Osiągnięto maksymalną liczbę zapisów na produkty. Spróbuj ponownie za 24 godziny.",
    "hourOne": "1 h",
    "hourOther": "{n} h"
  },
  "ca": {
    "invalidEmail": "Introdueix un correu electrònic vàlid.",
    "generic": "Alguna cosa ha fallat. Torna-ho a provar.",
    "tooMany": "Massa intents. Torna-ho a provar més tard.",
    "already": "Ja t’has subscrit a aquesta talla. Podràs tornar-ho a fer d’aquí a {time}.",
    "maxSizes": "Has arribat al màxim de {max} talles per a aquest producte. Torna-ho a provar d’aquí a 24 hores.",
    "maxProducts": "Has arribat al màxim de productes subscrits. Torna-ho a provar d’aquí a 24 hores.",
    "hourOne": "1 hora",
    "hourOther": "{n} hores"
  },
  "nl": {
    "invalidEmail": "Vul een geldig e-mailadres in.",
    "generic": "Er ging iets mis. Probeer het opnieuw.",
    "tooMany": "Te veel pogingen. Probeer het later opnieuw.",
    "already": "Je bent al ingeschreven voor deze maat. Je kunt je over {time} opnieuw inschrijven.",
    "maxSizes": "Je hebt het maximum van {max} maten voor dit product bereikt. Probeer het over 24 uur opnieuw.",
    "maxProducts": "Je hebt het maximale aantal productmeldingen bereikt. Probeer het over 24 uur opnieuw.",
    "hourOne": "1 uur",
    "hourOther": "{n} uur"
  },
  "el": {
    "invalidEmail": "Συμπλήρωσε ένα έγκυρο email.",
    "generic": "Κάτι πήγε στραβά. Δοκίμασε ξανά.",
    "tooMany": "Πάρα πολλές προσπάθειες. Δοκίμασε αργότερα.",
    "already": "Έχεις ήδη εγγραφεί για αυτό το μέγεθος. Μπορείς να εγγραφείς ξανά σε {time}.",
    "maxSizes": "Έφτασες το όριο των {max} μεγεθών για αυτό το προϊόν. Δοκίμασε ξανά σε 24 ώρες.",
    "maxProducts": "Έφτασες τον μέγιστο αριθμό εγγραφών σε προϊόντα. Δοκίμασε ξανά σε 24 ώρες.",
    "hourOne": "1 ώρα",
    "hourOther": "{n} ώρες"
  },
  "hr": {
    "invalidEmail": "Upiši ispravnu e-adresu.",
    "generic": "Nešto nije u redu. Pokušaj ponovno.",
    "tooMany": "Previše pokušaja. Pokušaj kasnije.",
    "already": "Već si prijavljen/a za ovu veličinu. Ponovno se možeš prijaviti za {time}.",
    "maxSizes": "Dosegnut je maksimum od {max} veličina za ovaj proizvod. Pokušaj ponovno za 24 sata.",
    "maxProducts": "Dosegnut je maksimalan broj proizvoda za obavijesti. Pokušaj ponovno za 24 sata.",
    "hourOne": "1 sat",
    "hourOther": "{n} h"
  }
};

function bisLang() {
  try {
    return (document.documentElement.lang || 'en').toLowerCase().slice(0, 2);
  } catch (e) {
    return 'en';
  }
}

function bisT(key, vars) {
  const pack = BIS_I18N[bisLang()] || BIS_I18N.en;
  let s = pack[key] || BIS_I18N.en[key] || '';
  Object.keys(vars || {}).forEach((k) => {
    s = s.split('{' + k + '}').join(String(vars[k]));
  });
  return s;
}

function bisHours(n) {
  return bisT(n === 1 ? 'hourOne' : 'hourOther', { n: n });
}

class BackInStockNotification {
  constructor() {
    this.KLAVIYO_PUBLIC_KEY = 'SY939f';
    this.KLAVIYO_LIST_ID = 'back-in-stock'; // You may need to adjust this
    this.modal = null;
    this.currentProduct = null;
    this.currentVariant = null;

    // Subscription limits
    this.LIMITS = {
      SAME_VARIANT_HOURS: 24, // Same email + product + variant
      VARIANTS_PER_PRODUCT: 3, // Max variants per product per email
      PRODUCTS_PER_EMAIL_HOURS: 24, // Time window for product limit
      MAX_PRODUCTS_PER_EMAIL: 10, // Max products per email in 24h
      REQUESTS_PER_HOUR: 15, // Max requests per browser per hour
      REQUEST_WINDOW_HOURS: 1, // Time window for request limit
    };

    this.STORAGE_KEYS = {
      SUBSCRIPTIONS: 'bis_subscriptions',
      REQUEST_LOG: 'bis_request_log',
    };

    this.init();
  }

  init() {
    // Wait for DOM to be ready
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => this.setup());
    } else {
      this.setup();
    }
  }

  setup() {
    this.modal = document.getElementById('BackInStockModal');
    if (!this.modal) {
      console.error('Back in Stock modal not found');
      return;
    }

    // Setup event listeners
    this.setupVariantListeners();
    this.setupModalListeners();
    this.setupNotifyButton();

    // Initial check for out-of-stock variant
    this.checkInitialVariant();

    // Arrived from a collection card's "Avísame" link
    this.autoOpenFromUrl();
  }

  /**
   * /products/handle?variant=123&notify=1 (link built by assets/my-size.js on
   * the collection cards): select that size and open the modal straight away,
   * so the shopper does not have to find the size and the notify button again.
   * notify=1 is removed from the URL afterwards so a reload does not reopen it.
   */
  autoOpenFromUrl() {
    let params;
    try {
      params = new URLSearchParams(window.location.search);
    } catch (error) {
      return;
    }
    if (params.get('notify') !== '1') return;

    const variantId = params.get('variant') || '';
    if (!/^\d+$/.test(variantId)) return;

    const input = document.querySelector(`.variant-input[data-variant-id="${variantId}"]`);
    if (!input) return;

    const run = () => {
      // a click also lets the theme's own variant picker react (price, URL…)
      if (!input.checked) {
        input.click();
      } else {
        this.handleVariantChange({ target: input });
      }

      const v = this.currentVariant;
      const soldOut = v && String(v.id) === variantId && !v.available && !v.continueSelling && v.inventory <= 0;
      if (soldOut) this.openModal();

      params.delete('notify');
      try {
        const qs = params.toString();
        history.replaceState(history.state, '', location.pathname + (qs ? '?' + qs : '') + location.hash);
      } catch (error) {
        // ignore
      }
    };

    // setup() runs on DOMContentLoaded, after the deferred theme scripts;
    // a tick later the variant picker is ready (no need to wait for images)
    setTimeout(run, 0);
  }

  setupVariantListeners() {
    // Listen to variant input changes
    const variantInputs = document.querySelectorAll('.variant-input');
    variantInputs.forEach((input) => {
      input.addEventListener('change', (e) => this.handleVariantChange(e));
    });
  }

  setupModalListeners() {
    // Close button
    const closeBtn = this.modal.querySelector('.back-in-stock-modal__close');
    if (closeBtn) {
      closeBtn.addEventListener('click', () => this.closeModal());
    }

    // Cancel button
    const cancelBtn = this.modal.querySelector('.back-in-stock-modal__button--cancel');
    if (cancelBtn) {
      cancelBtn.addEventListener('click', () => this.closeModal());
    }

    // Click outside modal content to close
    this.modal.addEventListener('click', (e) => {
      if (e.target === this.modal) {
        this.closeModal();
      }
    });

    // Form submission
    const form = document.getElementById('back-in-stock-form');
    if (form) {
      form.addEventListener('submit', (e) => this.handleFormSubmit(e));
    }

    // ESC key
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && !this.modal.classList.contains('hidden')) {
        this.closeModal();
      }
    });
  }

  setupNotifyButton() {
    // Find all notify buttons (there might be multiple for different sections)
    const notifyButtons = document.querySelectorAll('[id^="ProductNotifyButton-"]');
    notifyButtons.forEach((button) => {
      button.addEventListener('click', () => this.openModal());
    });
  }

  checkInitialVariant() {
    // Check if the initially selected variant is out of stock
    const selectedInput = document.querySelector('.variant-input:checked');
    if (selectedInput) {
      this.handleVariantChange({ target: selectedInput });
    }
  }

  handleVariantChange(event) {
    const input = event.target;
    const variantAvailable = input.dataset.variantAvailable === 'true';
    const continueSelling = input.dataset.continueSelling === 'true';
    const inventory = parseInt(input.dataset.inventory || '0');
    const variantId = input.dataset.variantId;
    const variantTitle = input.dataset.variantTitle;

    // Store current variant info
    this.currentVariant = {
      id: variantId,
      title: variantTitle,
      available: variantAvailable,
      continueSelling: continueSelling,
      inventory: inventory,
    };

    // Get product info from submit button
    const submitButton = document.querySelector('[id^="ProductSubmitButton-"]');
    if (submitButton) {
      this.currentProduct = {
        id: submitButton.dataset.productId,
        title: document.querySelector('.product__title h1, .product__title h2')?.textContent?.trim() || '',
        image: document.querySelector('.product__media img')?.src || '',
      };
    }

    // Show/hide notify button based on variant availability
    this.toggleNotifyButton(!variantAvailable && !continueSelling && inventory <= 0);
  }

  toggleNotifyButton(showNotify) {
    const submitButtons = document.querySelectorAll('[id^="ProductSubmitButton-"]');
    const notifyButtons = document.querySelectorAll('[id^="ProductNotifyButton-"]');
    const dynamicCheckoutContainers = document.querySelectorAll('.payment-buttons-container');

    if (showNotify) {
      // Show notify button, hide ATC and dynamic checkout
      submitButtons.forEach((btn) => btn.classList.add('hidden'));
      notifyButtons.forEach((btn) => btn.classList.remove('hidden'));
      dynamicCheckoutContainers.forEach((container) => container.classList.add('hidden'));
    } else {
      // Show ATC button, hide notify
      submitButtons.forEach((btn) => btn.classList.remove('hidden'));
      notifyButtons.forEach((btn) => btn.classList.add('hidden'));
      dynamicCheckoutContainers.forEach((container) => container.classList.remove('hidden'));
    }
  }

  openModal() {
    if (!this.modal || !this.currentProduct || !this.currentVariant) {
      console.error('Missing required data to open modal');
      return;
    }

    // Populate modal with product info
    this.populateModal();

    // Show modal
    this.modal.classList.remove('hidden');
    document.body.style.overflow = 'hidden';

    // Focus on email input
    setTimeout(() => {
      const emailInput = document.getElementById('back-in-stock-email');
      if (emailInput) emailInput.focus();
    }, 100);
  }

  closeModal() {
    if (!this.modal) return;

    this.modal.classList.add('hidden');
    document.body.style.overflow = '';

    // Reset form
    const form = document.getElementById('back-in-stock-form');
    if (form) form.reset();

    // Hide messages
    const error = document.getElementById('back-in-stock-error');
    const success = document.getElementById('back-in-stock-success');
    if (error) error.classList.add('hidden');
    if (success) success.classList.add('hidden');
  }

  populateModal() {
    // Product image
    const imageContainer = document.getElementById('back-in-stock-product-image');
    if (imageContainer && this.currentProduct.image) {
      imageContainer.innerHTML = `<img src="${this.currentProduct.image}" alt="${this.currentProduct.title}">`;
    }

    // Product title
    const titleElement = document.getElementById('back-in-stock-product-title');
    if (titleElement) {
      titleElement.textContent = this.currentProduct.title;
    }

    // Variant title
    const variantElement = document.getElementById('back-in-stock-variant-title');
    if (variantElement && this.currentVariant.title) {
      variantElement.textContent = this.currentVariant.title;
    }
  }

  async handleFormSubmit(event) {
    event.preventDefault();

    const form = event.target;
    const emailInput = document.getElementById('back-in-stock-email');
    const submitBtn = form.querySelector('.back-in-stock-modal__button--submit');
    const buttonText = submitBtn.querySelector('.back-in-stock-modal__button-text');
    const buttonSpinner = submitBtn.querySelector('.back-in-stock-modal__button-spinner');
    const errorElement = document.getElementById('back-in-stock-error');
    const successElement = document.getElementById('back-in-stock-success');

    // Validate email
    if (!emailInput.validity.valid) {
      this.showError(bisT('invalidEmail'));
      return;
    }

    const email = emailInput.value.trim().toLowerCase();

    // Check rate limits and subscription limits
    const limitCheck = this.checkSubscriptionLimits(email);
    if (!limitCheck.allowed) {
      this.showError(limitCheck.message);
      return;
    }

    // Show loading state
    submitBtn.disabled = true;
    buttonText.classList.add('hidden');
    buttonSpinner.classList.remove('hidden');
    errorElement.classList.add('hidden');
    successElement.classList.add('hidden');

    try {
      // Subscribe to Klaviyo
      await this.subscribeToKlaviyo(email);

      // Record subscription in localStorage
      this.recordSubscription(email);

      // Show success message with variant count
      const variantCount = this.getProductVariantCount(email, this.currentProduct.id);
      const successMessage = this.getSuccessMessage(variantCount);
      successElement.textContent = successMessage;
      successElement.classList.remove('hidden');

      // Close modal after 3 seconds
      setTimeout(() => {
        this.closeModal();
      }, 3000);
    } catch (error) {
      console.error('Back in stock subscription error:', error);
      this.showError(bisT('generic'));
    } finally {
      // Reset button state
      submitBtn.disabled = false;
      buttonText.classList.remove('hidden');
      buttonSpinner.classList.add('hidden');
    }
  }

  checkSubscriptionLimits(email) {
    // Clean up expired data first
    this.cleanupExpiredData();

    // Check browser request rate limit
    const requestCount = this.getRequestCount();
    if (requestCount >= this.LIMITS.REQUESTS_PER_HOUR) {
      return {
        allowed: false,
        message: bisT('tooMany'),
      };
    }

    // Get subscription data
    const subscriptions = this.getSubscriptions();
    const productId = this.currentProduct.id;
    const variantId = this.currentVariant.id;

    // Check if already subscribed to this exact variant
    const variantKey = `${email}:${productId}:${variantId}`;
    if (subscriptions[variantKey]) {
      const timeLeft = this.getTimeRemaining(subscriptions[variantKey].timestamp);
      return {
        allowed: false,
        message: bisT('already', { time: timeLeft }),
      };
    }

    // Check variant count for this product
    const variantCount = this.getProductVariantCount(email, productId);
    if (variantCount >= this.LIMITS.VARIANTS_PER_PRODUCT) {
      return {
        allowed: false,
        message: bisT('maxSizes', { max: this.LIMITS.VARIANTS_PER_PRODUCT }),
      };
    }

    // Check total product count for this email
    const productCount = this.getTotalProductCount(email);
    if (productCount >= this.LIMITS.MAX_PRODUCTS_PER_EMAIL) {
      return {
        allowed: false,
        message: bisT('maxProducts'),
      };
    }

    return { allowed: true };
  }

  getSubscriptions() {
    try {
      const data = localStorage.getItem(this.STORAGE_KEYS.SUBSCRIPTIONS);
      return data ? JSON.parse(data) : {};
    } catch (error) {
      console.error('Error reading subscriptions:', error);
      return {};
    }
  }

  recordSubscription(email) {
    try {
      const subscriptions = this.getSubscriptions();
      const productId = this.currentProduct.id;
      const variantId = this.currentVariant.id;
      const variantKey = `${email}:${productId}:${variantId}`;

      subscriptions[variantKey] = {
        email: email,
        productId: productId,
        variantId: variantId,
        variantTitle: this.currentVariant.title,
        productTitle: this.currentProduct.title,
        timestamp: Date.now(),
      };

      localStorage.setItem(this.STORAGE_KEYS.SUBSCRIPTIONS, JSON.stringify(subscriptions));

      // Record request
      this.recordRequest();
    } catch (error) {
      console.error('Error recording subscription:', error);
    }
  }

  getProductVariantCount(email, productId) {
    const subscriptions = this.getSubscriptions();
    let count = 0;
    const now = Date.now();
    const timeWindow = this.LIMITS.SAME_VARIANT_HOURS * 60 * 60 * 1000;

    for (const key in subscriptions) {
      const sub = subscriptions[key];
      if (sub.email === email && sub.productId === productId && now - sub.timestamp < timeWindow) {
        count++;
      }
    }

    return count;
  }

  getTotalProductCount(email) {
    const subscriptions = this.getSubscriptions();
    const products = new Set();
    const now = Date.now();
    const timeWindow = this.LIMITS.PRODUCTS_PER_EMAIL_HOURS * 60 * 60 * 1000;

    for (const key in subscriptions) {
      const sub = subscriptions[key];
      if (sub.email === email && now - sub.timestamp < timeWindow) {
        products.add(sub.productId);
      }
    }

    return products.size;
  }

  getRequestCount() {
    try {
      const data = localStorage.getItem(this.STORAGE_KEYS.REQUEST_LOG);
      const requests = data ? JSON.parse(data) : [];
      const now = Date.now();
      const timeWindow = this.LIMITS.REQUEST_WINDOW_HOURS * 60 * 60 * 1000;

      // Count requests within time window
      return requests.filter((timestamp) => now - timestamp < timeWindow).length;
    } catch (error) {
      console.error('Error reading request log:', error);
      return 0;
    }
  }

  recordRequest() {
    try {
      const data = localStorage.getItem(this.STORAGE_KEYS.REQUEST_LOG);
      let requests = data ? JSON.parse(data) : [];

      requests.push(Date.now());

      // Keep only requests within time window
      const now = Date.now();
      const timeWindow = this.LIMITS.REQUEST_WINDOW_HOURS * 60 * 60 * 1000;
      requests = requests.filter((timestamp) => now - timestamp < timeWindow);

      localStorage.setItem(this.STORAGE_KEYS.REQUEST_LOG, JSON.stringify(requests));
    } catch (error) {
      console.error('Error recording request:', error);
    }
  }

  cleanupExpiredData() {
    try {
      // Clean up subscriptions
      const subscriptions = this.getSubscriptions();
      const now = Date.now();
      const timeWindow = this.LIMITS.SAME_VARIANT_HOURS * 60 * 60 * 1000;
      let hasChanges = false;

      for (const key in subscriptions) {
        if (now - subscriptions[key].timestamp >= timeWindow) {
          delete subscriptions[key];
          hasChanges = true;
        }
      }

      if (hasChanges) {
        localStorage.setItem(this.STORAGE_KEYS.SUBSCRIPTIONS, JSON.stringify(subscriptions));
      }

      // Clean up request log (already done in getRequestCount, but we'll do it here too)
      const data = localStorage.getItem(this.STORAGE_KEYS.REQUEST_LOG);
      let requests = data ? JSON.parse(data) : [];
      const requestTimeWindow = this.LIMITS.REQUEST_WINDOW_HOURS * 60 * 60 * 1000;
      const cleanedRequests = requests.filter((timestamp) => now - timestamp < requestTimeWindow);

      if (cleanedRequests.length !== requests.length) {
        localStorage.setItem(this.STORAGE_KEYS.REQUEST_LOG, JSON.stringify(cleanedRequests));
      }
    } catch (error) {
      console.error('Error cleaning up data:', error);
    }
  }

  getTimeRemaining(timestamp) {
    const now = Date.now();
    const elapsed = now - timestamp;
    const timeWindow = this.LIMITS.SAME_VARIANT_HOURS * 60 * 60 * 1000;
    const remaining = timeWindow - elapsed;

    if (remaining <= 0) return bisHours(0);

    const hours = Math.ceil(remaining / (60 * 60 * 1000));
    return bisHours(hours);
  }

  getSuccessMessage(variantCount) {
    const locale = bisLang();

    const messages = {
      en: `Thanks! We'll notify you when this item is back in stock. You've subscribed to ${variantCount} size${
        variantCount > 1 ? 's' : ''
      } for this product.`,
      es: `¡Gracias! Te avisaremos cuando este artículo vuelva a estar disponible. Has suscrito ${variantCount} talla${
        variantCount > 1 ? 's' : ''
      } para este producto.`,
      fr: `Merci ! Nous vous notifierons lorsque cet article sera de nouveau en stock. Vous êtes inscrit à ${variantCount} taille${
        variantCount > 1 ? 's' : ''
      } pour ce produit.`,
      it: `Grazie! Ti avviseremo quando questo articolo sarà di nuovo disponibile. Hai sottoscritto ${variantCount} tagli${
        variantCount > 1 ? 'a' : 'o'
      } per questo prodotto.`,
      el: `Ευχαριστούμε! Θα σε ειδοποιήσουμε μόλις το προϊόν είναι ξανά διαθέσιμο. Έκανες εγγραφή για ${variantCount} ${
        variantCount > 1 ? 'μεγέθη' : 'μέγεθος'
      } αυτού του προϊόντος.`,
      de: `Danke! Wir benachrichtigen dich, sobald dieser Artikel wieder verfügbar ist. Du hast dich für ${variantCount} ${
        variantCount > 1 ? 'Größen' : 'Größe'
      } dieses Produkts angemeldet.`,
      pt: `Obrigado! Avisamos-te quando este artigo voltar a estar disponível. Subscreveste ${variantCount} ${
        variantCount > 1 ? 'tamanhos' : 'tamanho'
      } deste produto.`,
      pl: `Dziękujemy! Powiadomimy Cię, gdy ten produkt znów będzie dostępny. Zapisano Cię na ${variantCount} ${
        variantCount === 1 ? 'rozmiar' : variantCount < 5 ? 'rozmiary' : 'rozmiarów'
      } tego produktu.`,
      ca: `Gràcies! T’avisarem quan aquest article torni a estar disponible. T’has subscrit a ${variantCount} ${
        variantCount > 1 ? 'talles' : 'talla'
      } d’aquest producte.`,
      nl: `Bedankt! We laten het je weten zodra dit artikel weer op voorraad is. Je bent ingeschreven voor ${variantCount} ${
        variantCount > 1 ? 'maten' : 'maat'
      } van dit product.`,
      hr: `Hvala! Javit ćemo ti čim ovaj proizvod ponovno bude dostupan. Broj veličina za koje si prijavljen/a za ovaj proizvod: ${variantCount}.`,
    };

    return messages[locale] || messages.en;
  }

  async subscribeToKlaviyo(email) {
    // Use Klaviyo's client-side back-in-stock API
    const url = `https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=${this.KLAVIYO_PUBLIC_KEY}`;

    // Extract numeric variant ID from Shopify variant ID
    const variantId = this.currentVariant.id.toString().replace(/\D/g, '');

    // Format variant ID for Klaviyo: $shopify:::$default:::VARIANT_ID
    const klaviyoVariantId = `$shopify:::$default:::${variantId}`;

    const payload = {
      data: {
        type: 'back-in-stock-subscription',
        attributes: {
          profile: {
            data: {
              type: 'profile',
              attributes: {
                email: email,
              },
            },
          },
          channels: ['EMAIL'],
        },
        relationships: {
          variant: {
            data: {
              type: 'catalog-variant',
              id: klaviyoVariantId,
            },
          },
        },
      },
    };

    const response = await fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        revision: '2024-06-15',
      },
      body: JSON.stringify(payload),
    });

    // Client-side API returns 202 with no body on success
    if (response.status === 202) {
      return { success: true };
    }

    if (!response.ok) {
      const errorData = await response.json().catch(() => ({}));
      console.error('Klaviyo API Error:', errorData);
      throw new Error(`Klaviyo API returned ${response.status}`);
    }

    return { success: true };
  }

  showError(message) {
    const errorElement = document.getElementById('back-in-stock-error');
    if (errorElement) {
      errorElement.textContent = message;
      errorElement.classList.remove('hidden');
    }
  }
}

// Initialize when script loads
new BackInStockNotification();
